module.exports = __webpack_public_path__ + "static/media/ogs1.png.49fae2ef.jpg";